<template>
    <base-page :title="$t('l.deleted_keys')" icon="ios-key">
        <template slot="extra">
            <Button type="primary" @click="loadData">{{$t('l.fresh')}}</Button>
            <Input class="search-keyword" v-model="table.page.keyword" search suffix="ios-search" :placeholder="$t('l.remark67')"
                   @on-change="searchBlur" @on-search="loadData(1)" style="width: auto;margin-left: 5px"/>
        </template>
        <Row>
            <!-- 小区列表 -->
            <Col span="5">
                <community-tree @change="change"
                                @onToggleExpand="onToggleExpand"
                                @onTreeSelect="onTreeSelect"
                                :current_community="current_community"
                                :communitys="community.list"
                                :j_buildings="[]"></community-tree>
            </Col>
            <!-- 当前小区钥匙统计 -->
            <Col span="19">
                <div class="del-keys-box">
                        <Table :data="table.data" :columns="getColumns" :loading="table.loading"></Table>
                <Row type="flex" justify="center">
                    <Page size="small"
                          :current="table.page.current"
                          :page-size="table.page.size"
                          :total="table.page.total"
                          :page-size-opts="table.page.sizeOptions"
                          show-elevator show-sizer show-total
                          @on-page-size-change="($event)=>{table.page.size=$event;loadData(1)}"
                          @on-change="loadData"></Page>
                </Row>
                </div>
            </Col>
        </Row>
    </base-page>
</template>

<script>
    import basePage from "../my-components/base-page"
    import util from "../../libs/util"
    import communityTree from './components/community-tree'
    export default {
        name: "page_keys",
        components:{
            basePage,
            communityTree
        },
        data(){
            return{
                community:{
                    list:[],
                    expandNodes:[],
                    j_buildings: [],
                },
                current_community: {  //  当前操作小区
                    id: 0,
                    name: '',
                    // activeLable:''
                },
                table:{
                    data:[],
                    page: {
                        current: 1,  // 当前页
                        size: 24, // 每页个数
                        sizeOptions: [12, 18, 24],
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword:''
                    },
                    columns:[],
                    loading:false,
                },
                modal:{
                    show:false,

                }
            }
        },
        methods:{
            setPage(data){
                if (data.list){
                    this.table.data = data.list.map(it=>{
                        let json = JSON.parse(it.j_location);
                        it.address = json.building.name+json.unit.name
                        it.insert_time = new Date(it.insert_time).pattern('yyyy-MM-dd HH:mm:ss')
                        it.floor = JSON.parse(it.key_info).floorText
                        return it;
                    })
                }
                if (data.pageNumber) this.table.page.current = data.pageNumber;
                if (data.totalRow) this.table.page.total = data.totalRow;

            },
            loadData(){
                let current_community = localStorage.getItem("current_community")
                if (!current_community) {
                    this.$Message.warning(this.$t('l.hint63'))
                    return;
                }
                this.table.loading = true
                util.ajax.post("/owner/deletelist", {
                    page:this.table.page,
                    cid:JSON.parse(current_community).id
                }).then(res => {
                    if (!res.code) {
                        this.setPage(res.data)
                    }
                    this.table.loading = false
                })
            },
            searchBlur(){
                if (!this.table.page.keyword) this.loadData(1);
            },
            loadCommunitys() {
                util.ajax.get("/community/getlist").then(res => {
                    this.community.list = res.data;
                })
            },
            change(id) {
                this.current_community.activeLable = ""
                let community = this.community.list.find(item => (item.id == id));
                if (community) {
                    this.current_community.id = id
                    this.current_community.name = community.name
                    localStorage.setItem("current_community", JSON.stringify(this.current_community))
                    this.loadData();
                    return
                }
            },
            onTreeSelect(root, node, data,activeLable) { // 选择节点
                if (activeLable){
                    this.screen.building.id = 0
                    this.screen.unit.id = 0
                } else{
                    switch (data.type) {
                        case 'building':
                            this.screen.building.id = data.id
                            this.screen.unit.id = 0
                            break;
                        case 'unit':
                            this.screen.building.id = root[node.parent].node.id
                            this.screen.unit.id = data.id
                            break;
                    }
                }
                this.loadData();
            },
            onToggleExpand(node) {
                if (node.expand) {
                    this.expandNodes.push(node.id);
                } else {
                    this.expandNodes.splice(this.expandNodes.indexOf(node.id), 1);
                }
            },
        },
        computed:{
            getColumns(){
                return [
                    {
                        title:'ID',
                        key:'id',
                        align:'center',
                        width: 100
                    },
                    {
                        title: this.$t("l.address"),
                        key:'address',
                        align:'center',
                    },
                    {
                        title: this.$t("l.bound_lift"),
                        key:'dname',
                        align:'center',
                    },
                    {
                        title: this.$t("l.key_floor"),
                        key:'floor',
                        align:'center',
                    },
                    {
                        title: this.$t("l.delete_time"),
                        key:'insert_time',
                        align:'center',
                    },
                    {
                        title: this.$t("l.key_owner"),
                        key:'name',
                        align:'center',
                    },
                ]
            }
        },
        mounted(){
           if(localStorage.getItem("current_community")) this.current_community = JSON.parse(localStorage.getItem("current_community"));
           this.loadCommunitys();
           this.loadData();
        }
    }
</script>

<style scoped lang="less">
    .left-pane-card {
        margin-top: 20px;
    }
    .del-keys-box{
        margin-left: 40px;
    }
</style>